import React from 'react';

const EventOverview = () => {
  const keyTopics = [
    "How to make sense of tax systems and avoid costly mistakes.",
    "Best practices for employment contracts and freelance agreements.",
    "Basics of labor safety compliance in Colombia.",
    "The importance of having a strategic financial and legal foundation before scaling."
  ];

  return (
    <section className="bg-gray-100">
      <div className="pt-12">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 pb-6">
          <section className="pt-4">
            <p className="text-apple-gray-600 leading-relaxed mb-8">
              I had the honor of returning to my alma mater, the Universidad de Cartagena, as a guest speaker for an
              alumni event hosted by the Faculty of Engineering. This session focused on breaking down the most critical
              challenges that early-stage entrepreneurs and tech professionals face.
            </p>

            {/* Session Content */}
            <div className="bg-white p-8 rounded-xl shadow-sm border border-apple-gray-200">
              <h3 className="text-xl font-semibold text-apple-gray-800 mb-6">Key Topics Covered</h3>
              <ul className="space-y-4">
                {keyTopics.map((topic, index) => (
                  <li key={index} className="flex items-start">
                    <div className="flex-shrink-0 w-2 h-2 bg-apple-gray-600 rounded-full mt-2 mr-4"></div>
                    <span className="text-apple-gray-700">{topic}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default EventOverview;